var _defs, _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangleGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#000000",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rectangleGradient",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#000000",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#616161",
    stopOpacity: 0.01
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    fillOpacity: 0.8,
    d: "M37.7 128.9 9.8 101 100.4 10.4 156.2 10.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    fillOpacity: 0.8,
    d: "M156.2 94 100.4 94 79.5 114.9 107.4 142.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D47A1",
    d: "M79.5 170.7 100.4 191.6 156.2 191.6 156.2 191.6 107.4 142.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071, -0.7071, 0.7071, 0.7071, -77.667, 98.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.4,
    height: 39.4,
    x: 59.8,
    y: 123.1,
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.4,
    height: 5.5,
    x: 59.8,
    y: 162.5,
    fill: "url(#rectangleGradient)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 170.7 120.9 156.4 107.4 142.8",
    fill: "url(#triangleGradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.b8ce1645685e2eb5f4e99e33eca0de00.svg";
export { ForwardRef as ReactComponent };